module.exports = __webpack_public_path__ + "img/person.dd98ebe1.svg";